import { parseISO } from 'date-fns'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { useAppDispatch, useAppSelector } from '../../../store'
import { HealthState, setDates } from '../../../store/healthSlice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import DatePicker from '../../../components/v2/DatePicker'
import InfoMessage from '../../../components/v2/InfoMessage'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthStartDate = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const fakeData = {
    translations: {
      en: {
        stepName: 'start date',
      },
      ge: {
        stepName: 'საწყისი თარიღი',
      },
    },
  }
  //
  const stepName = fakeData.translations[lang].stepName
  //
  const isInsurancePeriodLoading = false
  //
  const mainLoading = isInsurancePeriodLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('insuranceStartDate')} />

        <HealthProgressbar stepName={stepName} />

        <FlexBlock>
          <WhiteBox>
            <DatePicker
              minDate={new Date()}
              className="start-date-class"
              label={`${t('startDate')}`}
              dateFormat="dd MMMM yyyy"
              selectedDate={filter.dates?.start ? parseISO(filter.dates.start as string) : null}
              onchange={(value) =>
                dispatch(
                  setDates({
                    start: dayjs(value).format('YYYY-MM-DD'),
                    end: dayjs(value).add(1, 'year').format('YYYY-MM-DD'),
                  }),
                )
              }
            />
          </WhiteBox>

          {filter.dates?.start && (
            <InfoMessage
              style={{
                maxWidth: '464px',
                marginTop: '24px',
              }}
              background="gray"
              variant="info"
              title={t('insurancePeriod')}
              text={t('insuranceStart')}
            />
          )}

          <RemainingCompanies
            text={
              lang === 'ge'
                ? `შეთავაზებების რაოდენობა ${3}`
                : lang === 'en'
                ? `${3} Companies are left with this options`
                : ''
            }
          />
        </FlexBlock>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/health-priority')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={filter.dates?.start ? false : true}
            onClick={() => navigate('/health-choose-method')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
//

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 80px;
  user-select: none;
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

const FlexBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 464px;
  width: 100%;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`

const WhiteBox = styled.div`
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 ${Colors.shadow};
  border-radius: 8px;
  padding: 32px 48px;
  width: 100%;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-popper {
    position: unset !important;
    transform: unset !important;
    margin-top: 10px;
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
  }

  ${Responsive.mobile} {
    padding: 24px 20px;
    margin-bottom: 24px;

    &:first-child {
      margin-top: 24px;
      margin-bottom: 20px;
    }
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

export default HealthStartDate
